export default defineAppConfig({
  feedbackEmail: 'info@sirena.team',
  feedbackConsoleMessages: [
    '%cЕсть ошибка? Пиши нам на info@sirena.team. Хочешь присоединиться к команде профессионалов? Заходи по ссылке на вакансии: https://www.sports.ru/tribuna/blogs/career/about/ Мы ищем талантливых специалистов!',
    'color: #00C78B; background: #161616; font-size: 30px',
  ],
});
